import React, { useEffect, useRef, useState } from 'react';
import { Roll, money, dollars } from './Ring';

const TONE = { lodged: 'var(--blue)', approved: 'var(--cyan)', settled: 'var(--green)' };
const VERB = { lodged: 'lodged', approved: 'approved', settled: 'settled' };

const ago = (e) => {
  if (e.ts) {
    const h = Math.max(0, Math.round((Date.now() - new Date(e.ts).getTime()) / 3600000));
    if (h < 1) return 'just now';
    if (h < 24) return `${h}h ago`;
  }
  const iso = e.at || '';
  const d = new Date(iso + (iso.length === 10 ? 'T12:00:00' : ''));
  const days = Math.round((Date.now() - d.getTime()) / 86400000);
  if (days <= 0) return 'today';
  if (days === 1) return 'yesterday';
  if (days < 7) return `${days}d ago`;
  return d.toLocaleDateString('en-AU', { day: 'numeric', month: 'short' });
};

export function Periods({ live }) {
  const P = live?.periods || {};
  const cols = [['today', 'Today'], ['week', 'This week'], ['month', 'This month']];
  return (
    <section className="gpj-panel" data-testid="gpj-periods">
      <div className="gpj-panel-h"><h2>Today, this week, this month</h2><p>Lodged, approved and settled</p></div>
      <div className="gpj-periods">
        {cols.map(([k, l]) => (
          <div className="gpj-period" key={k} data-testid={`gpj-period-${k}`}>
            <small>{l}</small>
            {['lodged', 'approved', 'settled'].map((t) => (
              <div className="gpj-prow" key={t}><span><i style={{ background: TONE[t] }} />{t[0].toUpperCase() + t.slice(1)}</span><strong><Roll value={money(P[k]?.[t])} /></strong></div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}

/* Newest-first feed built from real file dates; items that arrive between polls glow in. */
export function Feed({ live }) {
  const feed = live?.feed || [];
  const seen = useRef(null);
  const [fresh, setFresh] = useState(new Set());
  useEffect(() => {
    const keys = new Set(feed.map((e) => e.key));
    if (seen.current) {
      const n = new Set([...keys].filter((k) => !seen.current.has(k)));
      if (n.size) { setFresh(n); const t = setTimeout(() => setFresh(new Set()), 2500); return () => clearTimeout(t); }
    }
    seen.current = keys;
    return undefined;
  }, [feed]);
  return (
    <section className="gpj-panel" data-testid="gpj-feed">
      <div className="gpj-panel-h"><h2>Live activity</h2><p>Newest first</p></div>
      {feed.length === 0 ? <div className="gpj-empty">No lodgements, approvals or settlements yet.</div> : (
        <ul className="gpj-feed" aria-live="polite">
          {feed.map((e) => (
            <li key={e.key} className={fresh.has(e.key) ? 'new' : ''} data-testid={`gpj-feed-${e.type}`}>
              <span className="fd" style={{ background: TONE[e.type] }} />
              <span className="ft"><strong>{dollars(e.amount)} {VERB[e.type]}</strong><small>{e.client}{e.lender ? ` · ${e.lender}` : ''}{e.owner ? ` · ${e.owner}` : ''}</small></span>
              <time>{ago(e)}</time>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
